const getNonEmpty = <T>(array?: T[]): T[] | undefined => {
  return array && array.length > 0 ? array : undefined;
};

const arrayHelper = {
  getNonEmpty,
};

export default arrayHelper;
